import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { GetClientProfile } from "@/api/custom";

export interface User {
  advisor_cognito_id: string | null;
  client_id: string;
  cognito_id: string;
  created_at: string;
  date_of_birth: string;
  email: string;
  id: string;
  identity_id: string | null;
  name: string;
  phone_number: string;
  progress: Record<string, unknown>;
  signInDetails: {
    authFlowType: string;
    loginId: string;
  };
  updated_at: string;
  userId: string;
  username: string;
}

export interface UserinfoState {
  user: User | null;
  riaProfile: GetClientProfile;
}

const initialState: UserinfoState = {
  user: null,
  riaProfile: {
    profile: null,
    enabled_agreements: [],
    features: null,
  },
};

const userinfoSlice = createSlice({
  name: "userinfo",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setRiaProfile: (state, action: PayloadAction<GetClientProfile>) => {
      state.riaProfile = action.payload;
    },
  },
});

export const { setUser, setRiaProfile } = userinfoSlice.actions;

export const selectUser = (state: RootState) => state.userinfo.user;
export const selectRiaProfile = (state: RootState) => state.userinfo.riaProfile;

export default userinfoSlice.reducer;
